export default "__VITE_ASSET__hr9MYLgu__"